import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import Accordion from './Accordion';
import SmallAccordion from './SmallAccordion';

const Wrapper = styled.div`
  padding-top: 50px;
`;

const AccordionGroup = ({ items, noMargin, isEn, small }) => {
  const [open, setOpen] = useState([]);

  useEffect(() => {
    if (items && items.length > 0) {
      let states = [];
      items.forEach((element, i) => {
        states.push(false);
      });

      setOpen(states);
    }
  }, [items]);

  useEffect(() => {
    setOpen([])
  }, [small]);

  const update = (index, value) => {
    let states = [];

    if (items && items.length > 0) {
      items.forEach((element, i) => {
        states.push(value ? i === index : false);
      });

      setOpen(states);
    }
  };

  return (
    <Wrapper noMargin={noMargin}>
      {items &&
        items.length > 0 &&
        items.map((q, i) => {
          return small ? (
            <SmallAccordion
              key={`${q.title}${i}`}
              open={open[i] && open[i]}
              first={i === 0}
              index={i}
              update={update}
              data={q}
              isEn={isEn}
            />
          ) :  (
            <Accordion
              key={`${q.title}${i}`}
              open={open[i] && open[i]}
              first={i === 0}
              index={i}
              update={update}
              data={q}
              isEn={isEn}
            />
          );
        })}
    </Wrapper>
  );
};

export default AccordionGroup;
